export function RadioInput({ name, title, groupName, value1, text1, value2, text2, errorLabel, value,onChangeValue, hideMargin = false }) {
    let lang = localStorage.getItem("i18nextLng");
    const languageDir = "language-" + lang;
    return (
        <div className={"input nice-apply-theme " + languageDir} style={{ marginBottom: hideMargin ? '0rem' : null }}>

            {

                title &&
                <label className={"input-label "} htmlFor={name}>{title}</label>
            }

            <div className="nice-apply-theme">
                <label className={"input-radio nice-apply-theme  text-20"}>
                    <input radioGroup={groupName} onChange={() => onChangeValue(value1)} value={value1} checked={((value != value1)?false:true)} name={name} 
                    id="primary"
                    className={""} type="radio" />
                    {text1}
                </label>
                <label className={"input-radio nice-apply-theme text-20"}>
                    <input radioGroup={groupName} onChange={() => onChangeValue(value2)} value={value2} checked={((value != value2)?false:true)}  name={name} className={""}
                    
                    id="primary"
                    type="radio" />
                    {text2}

                </label>
            </div>
        </div>
    );
}
